import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { EnvironmentInstanceService } from './environment-instance.service';
import { WebSocketsService } from './services/web-sockets.service';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit, OnDestroy {

  private instance: string = null;
  private ws_url = '';
  constructor(
    private envService: EnvironmentInstanceService,
    private webSocketsService: WebSocketsService,
    private translate: TranslateService) {
    this.instance = environment.environment
    this.envService.setInstance(this.instance)
    translate.addLangs(['el', 'en'])
    // translate.setDefaultLang('el');
    translate.use(localStorage.getItem('lang') != null ? localStorage.getItem('lang') : 'el');
    localStorage.setItem('lang', localStorage.getItem('lang') != null ? localStorage.getItem('lang') : 'el')
  }

  ngOnInit() {
    // this.webSocketsService.connect(`${environment.ws}/realvalues/all`)
  }

  ngOnDestroy() { }
}
